import React from 'react'
import { ICustomerEmployment } from '../../../Interfaces/Customer/ICustomerEmployment';
import EmploymentInfo from './EmploymentInfo';
import { useSelector } from "react-redux";
import { AppState } from '../../../store/rootReducer';

interface IEmploymentInfoListProps {
  employmentInfo?: ICustomerEmployment[];
  onUpdateEmployment(employment: ICustomerEmployment): void;
  disabled?: boolean;
  isReadOnly: boolean;
}

const EmploymentInfoList: React.FC<IEmploymentInfoListProps> = (props) => {
  const lookups = useSelector((state: AppState) => state.applications.lookups);
  const handleUpdateEmployment = (emp: ICustomerEmployment): void => {
    props.onUpdateEmployment(emp);
  }

  return (
    <>
      {props.employmentInfo && props.employmentInfo.length > 0 ?
        [...props.employmentInfo].sort((x, y) => x.primaryEmployment < y.primaryEmployment
          ? 1
          : x.primaryEmployment !== y.primaryEmployment
            ? -1
            : x.companyName < y.companyName
              ? 1
              : -1
        ).map((e, key) =>
          <EmploymentInfo
            key={key}
            onUpdateEmployment={handleUpdateEmployment}
            employmentInfo={e}
            newEmploymentDialog={false}
            customerEmploymentStatuses={lookups.customerEmploymentStatuses}
            customerEmploymentVerificationOptions={lookups.customerEmploymentVerificationOptions}
            disabled={props.disabled}
            numberOfEmployments={props.employmentInfo?.length}
            isReadOnly={props.isReadOnly}
          />)
        : null}
    </>)
}

export default EmploymentInfoList;
